import { Injectable } from '@angular/core';
import { Router, Route, NavigationCancel } from '@angular/router';
import { AppService } from '@suite/app.service';
import { AuthService } from './auth.service';

import { NomWebServicesJson } from "@common/services/nom-web-services-json";
import { VisualStateService } from "@common/services/visual-state-service";
import { first } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class RouteGuard  {
    constructor(
        private appService: AppService,
        private router: Router,
        private authService: AuthService,
        public nomWebServicesJson: NomWebServicesJson,
        public visualStateService: VisualStateService
    ) { }

    canLoad(route: Route): Promise<boolean> {
        return new Promise(async (resolve) => {
            let path = route.path;
            if (this.getTokenFromPath(path)) {
                this.visualStateService.isDesktop = true;
                resolve(true);
                return;
            }

            if (this.getDesktopMode()) {
                this.visualStateService.isDesktop = true;
            }

            // const sub = this.router.events.pipe(first(_ => _ instanceof NavigationCancel)).subscribe((event: NavigationCancel) => {
            //     // event.url is the target route the user was attempting to reach
            //     let prevPath = event.url;
            //     if ((prevPath.indexOf('edit_assignment') > -1)) {
            //         const chunks = prevPath.split('/')
            //         const url = '/PST/playbook/' + chunks[3] + '/' + chunks[4]
            //         prevPath = url;
            //     }
            //     this.appService.redirectedPath = prevPath;
            //     sub.unsubscribe();
            // });

            const providerName = (localStorage.getItem('providerName')) ? localStorage.getItem('providerName') : '';
            const idToken = (localStorage.getItem('idToken')) ? localStorage.getItem('idToken') : '';
            const sessionDataStatus = await this.appService.loadSessionData();
            if (sessionDataStatus) {
                resolve(true);
                return;
            } else if (providerName === 'OKTA' && idToken) {
                await this.authService.loginWithToken(providerName);
            } else if (this.authService.isTokenValid(idToken)) {
                await this.authService.loginWithToken(providerName);
            } else if (localStorage.getItem('accessToken')) {
                await this.authService.loginWithToken(providerName);
            } else {
                this.nomWebServicesJson.clearSessionData();
                this.router.navigate(['/login'], { queryParamsHandling: 'preserve' } /*path.slice(path.indexOf('?'))*/ /*path.slice(path.indexOf('?'))*/);
                resolve(false);
                return;
            }
        });


    }

    private getDesktopMode(): boolean {
        return !!localStorage.getItem("DesktopMode");
    }

    private getTokenFromPath(path: string): string {
        let token = null;
        if (path) {
            let queryParamsIndex: number = path.indexOf("?");
            if (queryParamsIndex > -1) {
                let queryParamsStr: string = path.substring(queryParamsIndex + 1);
                if (queryParamsStr) {
                    let queryParamsArray: Array<string> = queryParamsStr.split("&");
                    if (queryParamsArray && (queryParamsArray.length > 0)) {
                        for (let param of queryParamsArray) {
                            if (param) {
                                let index = param.indexOf("=");
                                if (index > -1) {
                                    let key = param.substring(0, index);
                                    let value = param.substring(index + 1);
                                    if (key && (key == "token")) {
                                        token = decodeURIComponent(value);
                                        break;
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        return token;
    }
}
